import { localizable } from 'components/Localization';
import { FooterContainer } from 'components/PanelFooter';
import _ from 'lodash';
import { computed, observable } from 'mobx';
import { inject, observer, Observer } from 'mobx-react';
import {
  DefaultButton,
  PrimaryButton,
} from 'office-ui-fabric-react/lib/Button';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import React, { Component } from 'react';

import Page1 from './Page1';
import Page2 from './Page2';
import Page3 from './Page3';

const SaleEditStore = require(
  `../../../@${process.env.REACT_APP_TENANT}/containers/Sale/SaleEditSection/stores`
).default;

@inject('user', 'app', 'sale')
@localizable
@observer
export default class EditPanel extends Component {
  store = null;

  @observable page = 1;

  @computed get offerData() {
    return this.store.offerData;
  }

  @computed get docs() {
    return this.store.docs;
  }

  @computed get isPage1Valid() {
    return this.store.isPage1Valid;
  }

  @computed get isPage2Valid() {
    return this.store.isPage2Valid;
  }

  @computed get isPage3Valid() {
    return this.store.isPage3Valid;
  }

  componentWillMount() {
    const { user, app, offerData, docs } = this.props;
    this.store =
      typeof SaleEditStore.create === 'function'
        ? SaleEditStore.create(user, offerData, app.data)
        : new SaleEditStore(user); // backward compatibility
    this.store.initialize(offerData, docs);
  }

  @computed get canSave() {
    if (this.props.isRoundStarted) {
      switch (this.page) {
        case 1:
          return this.isPage1Valid;
        case 2:
          return this.isPage2Valid;
        case 3:
          return this.isPage3Valid;
        default:
      }
    }

    if (this.page !== this.props.sale.saleConfig.saleEditTotalPages) {
      return true;
    }

    return !_.some(this.docs, (d) => !d.type);
  }

  handleSave = async () => {
    const { saveValues, saveDocs } = this.props;
    const config = this.props.sale.saleConfig;

    if (this.page === config.saleEditTotalPages && !!config.saleEditDocs) {
      await saveDocs({ docs: this.docs });
    } else {
      await saveValues({ offerData: this.offerData });
    }
  };

  handleCancel = () => {
    const { cancel } = this.props;
    if (cancel) {
      cancel();
    }
  };

  handlePageStep = (step) => async () => {
    await this.handleSave();
    this.page = this.page + step;
  };

  handleSaveAndCancel = () => {
    this.handleSave();
    this.handleCancel();
  };

  render() {
    const { t, uploadDoc, deleteDoc, app, config } = this.props;
    const readonly = app.features.saleReadOnly;
    return (
      <Panel
        headerText={t('Edit offer form')}
        type={PanelType.medium}
        onDismiss={this.handleCancel}
        isOpen={true}
        isFooterAtBottom={true}
        closeButtonAriaLabel="Close"
        onRenderFooterContent={() => {
          return (
            <Observer
              render={() => (
                <FooterContainer>
                  {this.page > 1 && (
                    <DefaultButton
                      text={t('Previous')}
                      onClick={this.handlePageStep(-1)}
                    />
                  )}

                  {this.page <
                    this.props.sale.saleConfig.saleEditTotalPages && (
                    <PrimaryButton
                      disabled={!this.canSave}
                      text={t('Next')}
                      onClick={this.handlePageStep(+1)}
                    />
                  )}

                  {!readonly &&
                    this.page <
                      this.props.sale.saleConfig.saleEditTotalPages && (
                      <DefaultButton
                        disabled={!this.canSave}
                        text={t('Save')}
                        onClick={this.handleSaveAndCancel}
                      />
                    )}

                  {!readonly &&
                    this.page >=
                      this.props.sale.saleConfig.saleEditTotalPages && (
                      <PrimaryButton
                        disabled={!this.canSave}
                        text={t('Save')}
                        onClick={this.handleSaveAndCancel}
                      />
                    )}

                  <DefaultButton
                    text={t('Cancel')}
                    onClick={this.handleCancel}
                  />
                </FooterContainer>
              )}
            />
          );
        }}
      >
        {this.page === 1 && (
          <Page1
            sale={this.store}
            offerData={this.offerData}
            isRoundStarted={this.props.isRoundStarted}
            config={config}
          />
        )}
        {this.page === 2 && (
          <Page2
            isRoundStarted={this.props.isRoundStarted}
            sale={this.store}
            offerData={this.offerData}
            docs={this.docs}
            documentTypes={this.props.sale.saleConfig.documentTypes}
            uploadDoc={uploadDoc}
            deleteDoc={deleteDoc}
            config={config}
          />
        )}
        {this.page === 3 && (
          <Page3
            sale={this.store}
            offerData={this.offerData}
            docs={this.docs}
            documentTypes={this.props.sale.saleConfig.documentTypes}
            uploadDoc={uploadDoc}
            deleteDoc={deleteDoc}
            config={config}
          />
        )}
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/Sale/SaleEditSection/EditPanel.jsx